// Singleton wrapper around useRegisterSW
// Ensures the service worker is registered exactly once across the app.
import { useRegisterSW } from 'virtual:pwa-register/vue'

let _instance = null

export function useSwRegistration() {
  if (!_instance) {
    _instance = useRegisterSW({
      onRegistered(r) {
        if (!r) return
        const interval = 10 * 60 * 1000 // 10 minutes
        setInterval(() => { r.update() }, interval)
      }
    })
  }
  return _instance
}
